import { computed, watch } from "vue";
import { makeCommonAuthState } from "../commonAuthState.mjs";
import { useTypedBackendConfig } from "../../helpers.mjs";
import { useRuntimeConfig, useCookie, useState } from "#imports";
export const useAuthState = () => {
  const config = useTypedBackendConfig(useRuntimeConfig(), "local");
  const commonAuthState = makeCommonAuthState();
  const tokenNCookieName = `${config.token.cookiePrefix}_token.local`;
  const strategyCookieName = `${config.token.cookiePrefix}strategy`;
  const expiresAtCookieName = `${config.token.cookiePrefix}_token_expiration.local`;
  const _rawTokenCookie = useCookie(tokenNCookieName, {
    default: () => null,
    maxAge: config.token.maxAgeInSeconds,
    sameSite: config.token.sameSiteAttribute,
    secure: config.token.secureAttribute,
    domain: config.token.domainAttribute === "default" ? void 0 : config.token.domainAttribute
  });
  useCookie(strategyCookieName, {
    default: () => "local",
    sameSite: config.token.sameSiteAttribute,
    secure: config.token.secureAttribute,
    domain: config.token.domainAttribute === "default" ? void 0 : config.token.domainAttribute
  });
  const _expiresAtCookie = useCookie(expiresAtCookieName, {
    default: () => null,
    sameSite: config.token.sameSiteAttribute,
    secure: config.token.secureAttribute,
    domain: config.token.domainAttribute === "default" ? void 0 : config.token.domainAttribute
  });
  if (_rawTokenCookie.value && !_rawTokenCookie.value?.startsWith(config.token.type)) {
    _rawTokenCookie.value = `${config.token.type} ${_rawTokenCookie.value}`;
  }
  const rawToken = useState("auth:raw-token", () => _rawTokenCookie.value);
  watch(rawToken, () => {
    _rawTokenCookie.value = rawToken.value;
    if (!_expiresAtCookie.value) {
      _expiresAtCookie.value = Date.now() + config.token.maxAgeInSeconds * 1e3;
    }
  });
  const token = computed(() => {
    if (!rawToken.value) {
      return null;
    }
    if (rawToken.value.startsWith(config.token.type)) {
      return rawToken.value;
    }
    return config.token.type.length > 0 ? `${config.token.type} ${rawToken.value}` : rawToken.value;
  });
  const setToken = (newToken) => {
    rawToken.value = `${config.token.type} ${newToken}`;
  };
  const clearToken = () => {
    setToken(null);
  };
  const schemeSpecificState = {
    token,
    rawToken
  };
  return {
    ...commonAuthState,
    ...schemeSpecificState,
    setToken,
    clearToken
  };
};
export default useAuthState;
